import React, { useRef } from 'react';
import { useWorldStore } from '../state/worldStore';

// WasdControls — an on-screen WASD keycap cluster for LARGER views (desktop /
// non-touch), where the mobile joystick isn't shown. Clicking/holding a key
// drives the SAME movement as the physical keys by dispatching real keydown/
// keyup events with the matching `code` (WalkControls / InteriorWalk read
// keys.current[e.code]) — so no movement logic is duplicated. Doubles as a
// visible affordance that the world is walkable.
const KEYS = { W: 'KeyW', A: 'KeyA', S: 'KeyS', D: 'KeyD', shift: 'ShiftLeft' };

function press(code, down) {
  window.dispatchEvent(new KeyboardEvent(down ? 'keydown' : 'keyup', { code, bubbles: true }));
}

function Key({ label, wide = false, style }) {
  const held = useRef(false);
  const code = KEYS[label];
  const down = (e) => {
    e.preventDefault();
    if (held.current) return;
    held.current = true;
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch { /* noop */ }
    press(code, true);
  };
  const up = () => { if (!held.current) return; held.current = false; press(code, false); };
  return (
    <button
      onPointerDown={down} onPointerUp={up} onPointerCancel={up} onLostPointerCapture={up}
      onContextMenu={(e) => e.preventDefault()}
      style={{
        gridArea: undefined, width: wide ? 108 : 48, height: 48, borderRadius: 10, cursor: 'pointer',
        font: '700 15px system-ui, sans-serif', color: '#ffe9c4', userSelect: 'none', touchAction: 'none',
        background: 'rgba(20,22,26,0.42)', border: '1px solid rgba(255,255,255,0.22)',
        backdropFilter: 'blur(3px)', WebkitBackdropFilter: 'blur(3px)',
        boxShadow: 'inset 0 -2px 0 rgba(0,0,0,0.35), 0 2px 8px rgba(0,0,0,0.3)',
        display: 'grid', placeItems: 'center', ...style,
      }}
    >
      {label}
    </button>
  );
}

export default function WasdControls() {
  const micVisible = useWorldStore((s) => s.micVisible);
  return (
    <div style={{
      // Bottom-CENTER. Raised above the center quick-speak mic ONLY while it's
      // actually showing (AvatarChatDock) — drops back to the bottom when the mic
      // is gone (interiors, no target, guests).
      position: 'fixed', left: '50%', transform: 'translateX(-50%)',
      bottom: micVisible ? 'calc(max(16px, env(safe-area-inset-bottom)) + 78px)' : 'max(16px, env(safe-area-inset-bottom))',
      zIndex: 44, pointerEvents: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
    }}>
      <Key label="W" />
      <div style={{ display: 'flex', gap: 6 }}>
        <Key label="A" /><Key label="S" /><Key label="D" />
      </div>
      <Key label="shift" wide style={{ marginTop: 2, opacity: 0.9, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 }} />
      <div style={{ fontSize: 10.5, opacity: 0.55, color: '#ffe9c4', letterSpacing: 0.3 }}>drag/arrow to look · shift to run</div>
    </div>
  );
}
